import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BillingserviceService } from '../billingService.service';

@Component({
  selector: 'app-recovery-register-report',
  templateUrl: './recovery-register-report.component.html',
  styleUrls: ['./recovery-register-report.component.scss']
})
export class RecoveryRegisterReportComponent implements OnInit {
  startdate:any;
  enddate:any;
  checktranNo:any;
  refrencenumber:any;
  cleadingbankid:number =0;
  insurancecompanyid:number =0;
  insuranceCompanyArray: any = [];
  BnakType: any = [];
  recoveryRegisterArray :any =[];
  detailArray:any =[];
  showspinner:boolean =false;
  insuranceCtrl: FormControl;
  filteredInsurance: Observable<any[]>;
  clearingbankCtrl: FormControl;
  filteredclearingbank: Observable<any[]>;
  constructor(public authService: AuthService, public dialog: MatDialog,
    public dashboardService: DashboardService, private datePipe: DatePipe,
    public opdvisitService: OpdVisitService, public dialogRef: MatDialogRef<RecoveryRegisterReportComponent>,
    public router: Router, public billingservice: BillingserviceService,private exportdata:ExportService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    const currentdate = this.authService.getServerDate;
    var date = moment();
    var dateIn1Months = date.subtract(1, 'months');
    this.startdate = dateIn1Months.format('YYYY-MM-DD');
    this.enddate = this.datePipe.transform(currentdate, "yyyy-MM-dd");
    this.checktranNo =null;
    this.refrencenumber=null;
    this.insuranceCtrl = new FormControl();
    this.clearingbankCtrl = new FormControl();
    this.cleadingbankid=0;
    this.insurancecompanyid =0;
    this.GetInsuranceCompany();
    this.getbanktype();
  }
  closedialog() {
    this.dialogRef.close(0);
  }
  //date set 
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
   // get insurance company 
   GetInsuranceCompany() {
    this.insuranceCompanyArray = [];
    this.billingservice.GetInsuranceCompany().subscribe(item => {
      this.insuranceCompanyArray = item;
      this.mapInsuranceCPmany();
    })
  }

  //mapinsurancecompany 
  mapInsuranceCPmany(): void {
    this.insuranceCtrl = new FormControl();
    this.filteredInsurance = this.insuranceCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this.filterStates(state) : this.insuranceCompanyArray.slice())
      );
  }

  filterStates(name: string) {
    return this.insuranceCompanyArray.filter(state =>
      state.insuranceCoName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getInsuraceobj(event: any) {
   
    var val = event.option.value;
    const inusranceid = this.insuranceCompanyArray.filter(state =>
      state.insuranceCoName == val);
    this.insurancecompanyid = inusranceid[0].pK_InsuranceCoId;

  }
  CheckinputBlank(event:any){
   
    var checkdata=event.target.value;
    if(checkdata ==""){
     this.insurancecompanyid =0;
    }
   
}
  getbanktype() {
    this.BnakType = [];
    this.billingservice.getbankType().subscribe(data => {
      
      this.BnakType = data;
      this.mapClearingBank();
    })
  }

  // map autocomplete bank
  //mapinsurancecompany 
  mapClearingBank(): void {
    this.clearingbankCtrl = new FormControl();
    this.filteredclearingbank = this.clearingbankCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this.filterBank(state) : this.BnakType.slice())
      );
  }

  filterBank(name: string) {
    return this.BnakType.filter(state =>
      state.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getClearingBank(event: any) {
   
    var val = event.option.value;
    const inusranceid = this.BnakType.filter(state =>
      state.name == val);
    this.cleadingbankid = inusranceid[0].pK_Id;

  }
  CheckBankinput(event:any){
   
    var checkdata=event.target.value;
    if(checkdata ==""){
     this.cleadingbankid =0;
    }
   
}
  SHowRecord(){
 
    if(this.checktranNo ==null || this.checktranNo ==""){
      this.checktranNo =0;
    }
    if(this.refrencenumber ==null || this.refrencenumber ==""){
      this.refrencenumber =0;
    }
   
    this.recoveryRegisterArray =[];
    this.showspinner=true;
    this.billingservice.GetRecoveryRegisterrecord(this.startdate,this.enddate,this.insurancecompanyid,this.cleadingbankid,this.refrencenumber,this.checktranNo,).subscribe(item=> this.succesfullRecord(item),err=>this.errorRecord(err));
  }

  succesfullRecord(data){
    this.showspinner=false;
    if(data.length >0){
      this.recoveryRegisterArray =data;
    }else{
      this.dashboardService.openSnackBar("No data Found", "OK");
    }
  
 
  }
  errorRecord(err){
    this.showspinner=false;
    this.dashboardService.openSnackBar("No data Found", "OK");
  }
  rowDataretail(recoveryid:any){
   
    this.detailArray =[];
    try{
      this.showspinner=true;
      this.billingservice.GetRecoveryData(recoveryid).subscribe(item=>{
        this.showspinner=false;
        if(item.length >0){
          this.detailArray =item;
        }else{
          this.dashboardService.openSnackBar("No data Found", "OK");
        }
     
      });
    }catch(error){

    }
   
  }
  exportexcel(): void 
  { 
   
     let element = document.getElementById('recoverycontent'); 
     this.exportdata.exportxcel(element);
   }
  
   exportexcelDetail(): void {
    let element = document.getElementById('recoverycontentDetail'); 
    this.exportdata.exportxcel(element);
   }
}
